export function extraButtonsInit(){


  var $ = jQuery;

  $(document).on('click.dzswtl','.dzswtl-zoomsounds-loop-button',  handle_zoomsoundsLoopButton);
  $(document).on('click.dzswtl', '.dzswtl-button-toggler', handle_clickButtonToggler);


  function handle_zoomsoundsLoopButton(){

    var $t = $(this);
    var $targetDzsap = $($t.attr('data-aptarget'));

    if($targetDzsap.get(0) && $targetDzsap.get(0).api_media_toggleLoop){

      $targetDzsap.get(0).api_media_toggleLoop(!$t.hasClass('toggle-active'));
    }
  }
  function handle_clickButtonToggler(){
    var $t = $(this);

    if($t.hasClass('toggle-active')){
      $t.removeClass('toggle-active')
    }else{
      $t.addClass('toggle-active')
    }
  }
}